/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerslanguageen3Inputs */

const en_placeflyerslanguageen3 = /** @type {(inputs: Placeflyerslanguageen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const de_placeflyerslanguageen3 = /** @type {(inputs: Placeflyerslanguageen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {Placeflyerslanguageen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerslanguageen3 = /** @type {((inputs?: Placeflyerslanguageen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerslanguageen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerslanguageen3(inputs)
	return de_placeflyerslanguageen3(inputs)
});
export { placeflyerslanguageen3 as "placeFlyersLanguageEn" }